import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpoint = settings.api_host + "/user/password/recover";

const apiForgotPassword = async (email) => {
	if (!email) {
		throw new Error("Missing email");
	}
	try {
		// const response = await axios.post(endpoint, {
		// 	params: {
		// 		email
		// 	}
		// });

		var form = new FormData();
		form.append('email', email);

		const response = await axios({
			method: 'post',
			url: endpoint,
			data: form,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export default apiForgotPassword;


// WEBPACK FOOTER //
// ./src/api/forgotPassword.js